import { getMessage } from 'util/locale';

export const parseCropList = (cropList) => {
  const crops = {};
  cropList.data.forEach( (crop) => {
    const cropId = crop['legacy-id'];
    crop.id = cropId;
    crop.name = getMessage(`crop--${crop.code}`) || crop.name; // i18n for the name
    crops[crop.id] = crop;
    crops[crop['dfp-uuid']] = crop;
    crops[crop['code']] = crop;
  });
  return crops;
};
